import { TSuggest } from 'feature/registration/types'
// eslint-disable-next-line max-len
import { moveMapBySuggestCordsAndPlaceMark } from 'feature/YandexMap/redux/actions/moveMapBySuggestCordsAndPlaceMark'
import { useThunkDispatch } from 'store/hooks'

import { useAddressSliceActions } from './useAddressSliceActions'
import { AddressSliceKey } from './useAddressState'

// хук возвращает функцию onSelect которая
// принимает item: TSuggest
// при выполнение устанавливает item как текущий активный адрес, с меткой на карте.
// применять для выбора из списка предложных (которые приходят с дадаты)
export const useOnSelect = (addressKey: AddressSliceKey = 'default') => {
  const {
    setIsError,
    setErrorMessage,
    setInputAddress,
    setInputAddressSuggest,
    setIsValidAddress,
  } = useAddressSliceActions(addressKey)
  const thunkDispatch = useThunkDispatch()

  return (item: TSuggest) => {
    setInputAddress(item.address)
    setInputAddressSuggest(item)
    setIsError(false)
    setErrorMessage('')
    setIsValidAddress(true)
    if (addressKey !== 'company') {
      thunkDispatch(moveMapBySuggestCordsAndPlaceMark())
    }
  }
}
